module.exports = __webpack_public_path__ + "static/media/successplan-icon.ee8142e0.png";